import { gql } from "@apollo/client";

export const GET_SCAN_OTHER_DRIVER_PARCEL_DETAIL_FOR_CURRENT_DRIVER = gql`
    query GetScanOtherDriverParcelDetailForCurrentDriver($driverAccountId: Long!) {
        getScanOtherDriverParcelDetailForCurrentDriver(driverAccountId: $driverAccountId) {
            orderId
            deliveryTaskOrderId
            trackingNumber
            routeName
            assignedDriverName
            assignedDriverPhone
            misScannedDriverName
            misScannedDriverPhone
            scanTime
            isDriverNoReturnMarked
        }
    }
`;

export interface ScanOtherDriverParcelDetailType {
    orderId?: number | null;
    deliveryTaskOrderId?: number | null;
    trackingNumber: string;
    routeName: string;
    assignedDriverName: string;
    assignedDriverPhone: string;
    misScannedDriverName: string;
    misScannedDriverPhone: string;
    scanTime?: number | null;
    isDriverNoReturnMarked: boolean;
}

export interface ScanOtherDriverParcelDetailResponse {
    getScanOtherDriverParcelDetailForCurrentDriver: ScanOtherDriverParcelDetailType[];
}
